const CompareResult = {
  eq: 1,
  lt: 2,
  gt: 3
};
const compareFunc = (currentValue, targetValue) => {
  // 传入的比较方法，通过比较顶部距离与最上方节点的bottom值来决定列表的第一个元素
  if (currentValue === targetValue) {
    return CompareResult.eq;
  }
  if (currentValue < targetValue) {
    return CompareResult.lt;
  }
  return CompareResult.gt;
};
// 二分查找核心算法
export const binarySearch = (list, targetValue, height) => {
  let start = 0;
  let end = list.length - 1;
  let tempIndex = null;
  while (start <= end) {
    tempIndex = Math.floor((start + end) / 2);
    const mid = list[tempIndex];
    const compareRes = compareFunc((mid._index + 1) * height, targetValue);
    // 一般情况是找不到完全相等的值，只能找到最接近的值
    if (compareRes === CompareResult.eq) {
      return tempIndex;
    }
    if (compareRes === CompareResult.lt) {
      start = tempIndex + 1;
    } else if (compareRes === CompareResult.gt) {
      end = tempIndex - 1;
    }
  }
  return tempIndex;
};
